import { render, staticRenderFns } from "./point-center.vue?vue&type=template&id=346923bf&scoped=true"
import script from "./point-center.vue?vue&type=script&lang=js"
export * from "./point-center.vue?vue&type=script&lang=js"
import style0 from "./point-center.vue?vue&type=style&index=0&id=346923bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346923bf",
  null
  
)

export default component.exports